export default ['daily', 'weekly', 'monthly', 'yearly'];
